<template>
	
	<v-dialog
	    v-model="visible"
		persistent
	    width="700"
		class="edit-dialog"
		ref="editDialog"
		eager
	>
		<v-card>
			<v-card-title class="text-subtitle-1 white--text info" color="darkseagreen" ref="editDialogTitle">
				{{title}}
			</v-card-title>
			<v-card-text  class="pb-0">
				<div v-if="mode==1" class="flex-grow-0 flex-shrink-0 pt-3 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-2 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">父节点代码:</label>
						<v-text-field 
							class="form-item-value py-0 mr-0 readonly_input_item" 								
							outlined
							dense 
							placeholder=""
							readonly
							:value="higher.moduleFuncCode"
						>
						</v-text-field>						
					</div>
					<div class="form-item form-item-width-1 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">父节点编号:</label>
						<v-text-field 
							class="form-item-value py-0 mr-0 readonly_input_item" 								
							outlined
							dense
							placeholder=""
							readonly
							:value="higher.moduleFuncId"
						>
						</v-text-field>						
					</div>
				</div>
				<div v-if="mode==1" class="flex-grow-0 flex-shrink-0 pt-3 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-3 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">父节点名称:</label>
						<v-text-field 
							class="form-item-value py-0 mr-0  readonly_input_item" 								
							outlined
							dense
							placeholder=""
							readonly
							:value="higher.moduleFuncName"
						>
						</v-text-field>						
					</div>
				</div>
				
				<div v-if="mode==2" class="flex-grow-0 flex-shrink-0 pt-3 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-2 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">同级节点代码:</label>
						<v-text-field 
							class="form-item-value py-0 mr-0 readonly_input_item" 								
							outlined
							dense 
							placeholder=""
							readonly
							:value="sameLevel.moduleFuncCode"
						>
						</v-text-field>						
					</div>
					<div class="form-item form-item-width-1 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">同级节点编号:</label>
						<v-text-field 
							class="form-item-value py-0 mr-0 readonly_input_item" 								
							outlined
							dense
							placeholder=""
							readonly
							:value="sameLevel.moduleFuncId"
						>
						</v-text-field>						
					</div>
				</div>
				<div v-if="mode==2" class="flex-grow-0 flex-shrink-0 pt-3 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-3 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">同级节点名称:</label>
						<v-text-field 
							class="form-item-value py-0 mr-0 readonly_input_item" 								
							outlined
							dense
							placeholder=""
							readonly
							:value="sameLevel.moduleFuncName"
						>
						</v-text-field>						
					</div>
				</div>
				
				<div v-if="mode==3" class="flex-grow-0 flex-shrink-0 pt-3 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-2 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">原节点代码:</label>
						<v-text-field 
							class="form-item-value py-0 mr-0 readonly_input_item" 								
							outlined
							dense 
							placeholder=""
							readonly
							:value="editOri.moduleFuncCode"
						>
						</v-text-field>						
					</div>
					<div class="form-item form-item-width-1 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">原节点编号:</label>
						<v-text-field 
							class="form-item-value py-0 mr-0 readonly_input_item" 								
							outlined
							dense
							placeholder=""
							readonly
							:value="editOri.moduleFuncId"
						>
						</v-text-field>						
					</div>
				</div>
				<div v-if="mode==3" class="flex-grow-0 flex-shrink-0 pt-3 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-3 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">原节点名称:</label>
						<v-text-field 
							class="form-item-value py-0 mr-0 readonly_input_item" 								
							outlined
							dense
							placeholder=""
							readonly
							:value="editOri.moduleFuncName"
						>
						</v-text-field>						
					</div>
				</div>
				
				<v-divider></v-divider>
				<!--编辑区 -->
				<div class="flex-grow-0 flex-shrink-0 pt-3 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-2 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">功能代码:</label>
						<v-text-field 
							class="form-item-value py-0 mr-0"
							:class="{'careful_input_item':mode==3}"
							outlined
							dense
							placeholder=""
							v-model="editing.moduleFuncCode"							
						>
						</v-text-field>						
					</div>
				</div>
				
				<div class="flex-grow-0 flex-shrink-0 pt-1 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-3 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">功能名称:</label>
						<v-text-field 
							class="form-item-value py-0 mr-0" 								
							outlined
							dense
							placeholder=""
							v-model="editing.moduleFuncName"
						>
						</v-text-field>						
					</div>
				</div>
				
				<div class="flex-grow-0 flex-shrink-0 pt-1 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-2 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">功能类型:</label>
						<v-select
						class="form-item-value py-0 mr-0" 	
						v-model="editing.type"
						:items="moduleFuncTypes"						
						label=""
						hide-details											
						flat
						solo
						outlined
						dense						
						return-object
						item-text="typeName"
						item-value="typeId"
						full-width						
						>
						</v-select>					
					</div>

          <div class="form-item form-item-width-1 pr-1 ma-0"  v-if="editing.type.typeId == 5">
            <label class="form-item-label py-0 mt-0 mr-0">网页类型:</label>
            <v-select
                class="form-item-value py-0 mr-0"
                v-model="editing.webpageType"
                :items="webpageTypes"
                label=""
                hide-details
                flat
                solo
                outlined
                dense
                return-object
                item-text="typeName"
                item-value="typeId"
                full-width
            >
            </v-select>
          </div>
				</div>
				
				<div class="flex-grow-0 flex-shrink-0 pt-1 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-1 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">访问方法:</label>
						<v-select
						class="form-item-value py-0 mr-0" 	
						v-model="editing.method"
						:items="httpRequestMethods"						
						label=""
						hide-details											
						flat
						solo
						outlined
						dense						
						return-object
						item-text="methodName"
						item-value="methodId"
						full-width						
						>
						</v-select>
										
					</div>
				</div>
				
				<div class="flex-grow-0 flex-shrink-0 pt-1 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-3 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">访问路径:</label>
						<v-text-field 
							class="form-item-value py-0 mr-0" 								
							outlined
							dense
							placeholder=""							
							:value="editing.moduleFuncPath"
							v-model="editing.moduleFuncPath"
						>
						</v-text-field>						
					</div>
				</div>
                <div class="flex-grow-0 flex-shrink-0 pt-1 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-2 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">路由名:</label>
						<v-text-field 
							class="form-item-value py-0 mr-0" 								
							outlined
							dense
							placeholder=""							
							:value="editing.routeName"
							v-model="editing.routeName"
						>
						</v-text-field>						
					</div>
				</div>
				
				
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
			  <v-spacer></v-spacer>
			  <v-btn
				color="blue-grey"
				class="left-round"
				@click="setVisible(false)"
			  >
				<span class="px-2"><v-icon>mdi-file-cancel-outline</v-icon></span>
				取消
			  </v-btn>
			  <v-btn
				color="success"
				class="right-round"
				@click="handleSave"
			  >				
				保存
				<span class="px-2"><v-icon>mdi-content-save-move-outline</v-icon></span>
			  </v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
	
</template>

<script>
	import {default as ModuleFuncTypeApi} from "../../../../api/smp/sys/ModuleFuncTypeApi.js";
	import {default as HttpRequestMethodApi} from "../../../../api/smp/sys/HttpRequestMethodApi.js";
	import {default as ModuleFunctionApi} from "../../../../api/smp/sys/ModuleFunctionApi.js";
	import {default as DragSupport} from '../../../../util/drag.js';
	
	export default {
		name: 'EditModuleFuncDialog',
		components: {
		},
		data: () => ({
			visible:false,
			mode:0, //1新增下级，2新增同级 3编辑
			higher:{},
			sameLevel:{},
			editOri:{},
			editing:{
				moduleFuncId:"",
				moduleFuncCode:"",
				moduleFuncName:"",
				type:"",
        webpageType:"",
				method:"",
                moduleFuncPath:"",
                routeName:"",
			},
			moduleFuncTypes:[],
      webpageTypes:[],
			httpRequestMethods:[]
		}),
		methods:{
			async  errMsg(title,text){
				await this.$dialog.error({
					text: text,
					title: title
				});
			},
			async  infoMsg(title,text){
				await this.$dialog.info({
					text: text,
					title: title
				});
			},
			setVisible(v){
                /*
				this.visible=v;
				if(this.visible==true)
					DragSupport.bind(this.$refs.editDialog.$refs.dialog);
				else
					DragSupport.unbind(this.$refs.editDialog.$refs.dialog);
                */
                this.visible=v;
                let dialogEl = this.$refs.editDialog.$refs.dialog;
                
				if(this.visible==true)
					DragSupport.bind(dialogEl,this.$refs.editDialogTitle);
				else
					DragSupport.unbind(dialogEl);    
			},
			setMode(m){
				this.mode=m;
				this.clearInput();
			},
			setHigher(h){
				this.higher = h;
			},
			setSameLevel(sl){
				this.sameLevel = sl;
			},
			setEdit(e){
				this.editOri = e;
				this.editing.moduleFuncCode=e.moduleFuncCode;
				this.editing.moduleFuncName=e.moduleFuncName;
				this.editing.moduleFuncId=e.moduleFuncId;
				this.editing.type={typeId:e.typeId};
				this.editing.webpageType = {typeId:e.webpageTypeId};
				this.editing.method={methodId:e.methodId};
                this.editing.moduleFuncPath=e.path;
                this.editing.routeName=e.routeName;
			},
			clearInput(){
				this.editing={
					moduleFuncId:"",
					moduleFuncCode:"",
					moduleFuncName:"",
					type:{typeId:"",typeName:""},
          webpageType:{typeId:"",typeName:""},
					method:{methodId:"",methodName:""},
                    moduleFuncPath:"",
                    routeName:""
				};
			},
			handleSave(){
				let me = this;
				if((!this.editing.moduleFuncCode)||(this.editing.moduleFuncCode.trim()=='')){
					me.errMsg('错误','还没有输入模块功能代号');
					return;
				}
				if((!this.editing.moduleFuncName)||(this.editing.moduleFuncName.trim()=='')){
					me.errMsg('错误','还没有输入模块功能名称');
					return;
				}
				if((!this.editing.type)||(this.editing.type.typeId.trim()=='')){
					me.errMsg('错误','还没有选择模块功能类型');
					return;
				}
				
				if(this.editing.type.typeId==1){
					if((!this.editing.method)||(this.editing.method.methodId.trim()=='')){
						me.errMsg('错误','API类型需要选择http请求方法');
						return;
					}
				}
				if((this.editing.type.typeId==3)&&((!this.editing.moduleFuncPath)||(this.editing.moduleFuncPath.trim()==''))){
					me.errMsg('错误','Vue组件必须录入路径');
					return;
				}

        if(this.editing.type.typeId == 5 &&
            ((!this.editing.webpageType)||(!this.editing.webpageType.typeId)||(this.editing.webpageType.typeId.trim()==''))){
          me.errMsg('错误','还没有选择网页类型');
          return;
        }

				if((this.mode==3)&&((!this.editing.moduleFuncId)||(this.editing.moduleFuncId.trim()==''))){
					me.errMsg('错误','修改操作没有找到输入模块功能编号，需要连续系统管理员');
					return;
				}
				
				let requestData={
					mode:me.mode,
					moduleFunction:{
						moduleFuncId:me.editing.moduleFuncId,
						moduleFuncCode:me.editing.moduleFuncCode,
						moduleFuncName:me.editing.moduleFuncName,
						typeId:me.editing.type.typeId,
            webpageTypeId:me.editing.webpageType.typeId,
						methodId:me.editing.method.methodId,
                        path:me.editing.moduleFuncPath,
                        routeName:me.editing.routeName,
					}
				};
				if(me.mode==1){
					requestData.moduleId = me.higher.moduleId;
					requestData.higherId = me.higher.moduleFuncId;
				}else if(me.mode==2){
					requestData.moduleId = me.sameLevel.moduleId;
					requestData.sameLevelId= me.sameLevel.moduleFuncId;
				}else if(me.mode==3){
					requestData.moduleId = me.editOri.moduleId;
					requestData.editingId=me.editOri.moduleFuncId;
				}
				
				requestData.moduleFunction.moduleId=requestData.moduleId;

				//开始发送请求
				ModuleFunctionApi.persistModuleFunction(requestData).then(function(resp){
					console.log(resp);
					let data = resp.data;
					if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
						let msg=data.msg;
						msg = ((!msg)||(msg==''))?'保存模块功能信息失败':msg;
						if(data.msg_detail)
							msg = msg +'('+data.msg_detail+')';
						throw new Error(msg);
						return;
					}
					
					let moduleFunction = data.data.moduleFunction;
					console.log("persist moduleFunction finished");
					console.log(moduleFunction);
					me.infoMsg('成功','模块功能数据已经保存');
					me.setVisible(false);
					if((me.mode==1) || (me.mode==2))
						me.$emit("moduleFunctionAdded",moduleFunction);
					else if(me.mode==3)	
						me.$emit("moduleFunctionUpdated",moduleFunction);
				}).catch(function(err){
					console.log(err.stack);
					console.log(err);
					me.errMsg('错误','保存模块功能信息失败:'+err.message);
				});
			},
			loadModuleFuncTypes(){
				let me = this;
				ModuleFuncTypeApi.queryModuleFuncType().then(function(resp){
					let data = resp.data;
					if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
						let msg=data.msg;
						msg = ((!msg)||(msg==''))?'获取模块功能类型信息失败':msg;
						throw new Error(msg);
						return;
					}

					let moduleFuncTypes = data.data.moduleFuncTypes;
					console.log("request moduleFuncTypes returned:");
					console.log(moduleFuncTypes);
					me.moduleFuncTypes = moduleFuncTypes
				}).catch(function(err){
					console.log(err);
					me.errMsg('错误','获取模块功能类型信息失败:'+err.message);
				});
			},
			loadHttpRequestMethods(){
				let me = this;
				HttpRequestMethodApi.queryHttpRequestMethod().then(function(resp){
					let data = resp.data;
					if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
						let msg=data.msg;
						msg = ((!msg)||(msg==''))?'获取HTTP访问方法类型信息失败':msg;
						throw new Error(msg);
						return;
					}

					let httpRequestMethods = data.data.httpRequestMethods;
					console.log("request httpRequestMethods returned:");
					console.log(httpRequestMethods);
					me.httpRequestMethods = httpRequestMethods;
				}).catch(function(err){
					console.log(err);
					me.errMsg('错误','获取HTTP访问方法类型信息失败:'+err.message);
				});
			},
      loadWebpageTypes(){
        let me = this;
        ModuleFuncTypeApi.queryWebpageType().then(function(resp){
          let data = resp.data;
          if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
            let msg=data.msg;
            msg = ((!msg)||(msg==''))?'获取模块功能网页类型信息失败':msg;
            throw new Error(msg);
            return;
          }

          let webpageTypes = data.data.moduleFuncTypes;
          console.log("request webpageTypes returned:");
          console.log(webpageTypes);
          me.webpageTypes = webpageTypes
        }).catch(function(err){
          console.log(err);
          me.errMsg('错误','获取模块功能网页类型信息失败:'+err.message);
        });
      },
		},
		computed:{
			title(){
				if(this.mode==1)
					return "增加模块/功能(下级)";
				else if(this.mode==2)
					return "增加模块/功能(同级)";
				else if(this.mode==3)
					return "编辑模块/功能";
				else
					return "未知操作";			
			}
		},
		mounted(){
			this.loadModuleFuncTypes();
			this.loadHttpRequestMethods();
			this.loadWebpageTypes();
		}
	}
</script>

<style scoped>
	.edit-dialog{
		border-radius: 4px;
	}
	.readonly_input_item{
		background-color:lightgray;
	}
	.careful_input_item{
		background-color:lightblue;
	}
</style>
